import { Injectable } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class PgIconRegistry {
  private _svgIconConfigs = new Map<string, SafeResourceUrl>();

  addSvgIcon(name: string, url: SafeResourceUrl) {
    this._svgIconConfigs.set(name, url);
  }

  getSvgIcon(name: string, url: SafeResourceUrl) {
    return this._svgIconConfigs.get(name);
  }
}
